import type { PaginatedResponse, PaginationMeta } from '@models/pagination'
import type { Vehicle, VehicleFilters } from '@models/vehicle'
import type { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import vehiclesApi from './actions'
import { vehiclesKeys } from './constants'

export interface UseVehiclesData {
  vehicles: Vehicle[]
  vehiclesMap: Map<number, Vehicle>
  pagination: PaginationMeta
}

const selectData = ({
  data,
  pagination,
}: PaginatedResponse<Vehicle>): UseVehiclesData => ({
  vehicles: data,
  vehiclesMap: new Map(data.map(vehicle => [vehicle.id, vehicle])),
  pagination,
})

const useVehicles = (filters: VehicleFilters) => {
  const query = useQuery<
    PaginatedResponse<Vehicle>,
    AxiosError,
    UseVehiclesData
  >(vehiclesKeys.list(filters), () => vehiclesApi.getVehicles(filters), {
    select: selectData,
    enabled: !!filters.companyId,
  })
  return query
}

export default useVehicles
